import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-174f8018"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "load fail"
})], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "container-project_name"
}, " 物流管理系统 0.0.3 ", -1));
const _hoisted_4 = {
  class: "user-msg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Fold = _resolveComponent("Fold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_Expand = _resolveComponent("Expand");
  const _component_arrow_down = _resolveComponent("arrow-down");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "container-header"
    }, {
      default: _withCtx(() => [_createElementVNode("section", null, [($props.type === 'manage' ? $props.menuList.length : _ctx.$route.meta.tooltipVisible) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$data.show ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        disabled: $data.foldDisabled,
        effect: "light",
        content: "点击收缩",
        placement: "right-start"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 30,
          color: "#fff",
          class: "toggle-btn",
          onClick: _cache[0] || (_cache[0] = $event => $options.openCollapse('fold'))
        }, {
          default: _withCtx(() => [_createVNode(_component_Fold)]),
          _: 1
        })]),
        _: 1
      }, 8, ["disabled"])) : (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 1,
        disabled: $data.expandDisabled,
        effect: "light",
        content: "点击展开",
        placement: "right-start"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 30,
          color: "#fff",
          class: "toggle-btn",
          onClick: _cache[1] || (_cache[1] = $event => $options.openCollapse('expand'))
        }, {
          default: _withCtx(() => [_createVNode(_component_Expand)]),
          _: 1
        })]),
        _: 1
      }, 8, ["disabled"]))])) : _createCommentVNode("", true), _hoisted_2, _hoisted_3]), _createElementVNode("section", null, [_createVNode(_component_el_dropdown, {
        style: {
          "color": "#fff"
        },
        trigger: "click",
        onCommand: $options.handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "logout"
          }, {
            default: _withCtx(() => [_createTextVNode(" 退出登录 ")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createTextVNode(" 欢迎您," + _toDisplayString(_ctx.$store.state.adminInfo.name) + " ", 1), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_arrow_down)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["onCommand"])])]),
      _: 1
    }), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  });
}